import api from 'utils/api';
import firebase from 'utils/auth/firebase';
import { BASE_API_URL } from 'api/constants';

export const getJWTToken = async () => {
  const userId = await firebase?.auth()?.currentUser?.uid;

  return api.get(`${BASE_API_URL}/auth/${userId}/jwt/`).then((response) => response?.data?.jwtToken);
};
